import React, { useState } from 'react';
import TierHeader from './TierHeader';
import TierLegends from './TierLegends';
import { Collapse } from 'reactstrap';
import TierNode from './TierNode';
import { Framework, Tier3 } from 'src/shared/types/src';

const TierThree = ({ _framework, expand }: { _framework: Framework, expand: boolean }) => {
  const [isVisible, setIsVisible] = useState(expand);
  const assessments = _framework.assessments as Tier3;

  return (
    <div className='framework-tier-wrap'>
      <TierHeader tierTitle={_framework.name} onClick={() => setIsVisible(!isVisible)} isVisible={isVisible} />
        <Collapse isOpen={isVisible}> 
          <div className='mg-t-10'>
            <TierLegends assessmentLevels={_framework.assessmentLevel} />
            <div className='mg-t-5'>
              { assessments?.areas?.map((areas, index) => 
                <TierNode content={areas.name} key={index} borderColor={areas.color} customLabelStyle={'fw-semibold'}>
                  {
                    areas?.aspects?.map((aspect, index) => 
                      <TierNode content={aspect.name} key={index} borderColor={aspect.color} customLabelStyle={'fw-semibold'}>
                        {
                          aspect?.statements?.map((statement, index) => 
                            <TierNode content={statement.name} label={statement.label} iconType={statement.iconType} key={index} borderColor={statement.color} isStatement={true} />
                          )
                        }
                      </TierNode>
                    )
                  }
                </TierNode>
              )}
            </div>
          </div>
        </Collapse>
    </div>
  );
};

export default TierThree;
